import { IconButton } from "@material-ui/core";
import { Download } from "@mui/icons-material";
import React from "react";

const useStyle = (icon) => {
  return {
    containerStyle: {
      display: "flex",
      width: "calc(100% / 2)",
      alignItems: "center",
      margin: "16px 0px",
    },
    index: {
      color: "#362B73",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "24px",
      opacity: "0.56",
      margin: 0,
    },
    iconStyle: {
      width: "16px",
      height: "16px",
      borderRadius: "4px",
      background: icon,
      margin: 12,
    },
    header: {
      color: "#362B73",
      fontFamily: "Inter",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "24px",
      margin: 0,
      width: "60%",
    },
    info: {
      color: "#362B73",
      textAlign: "right",
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "20px",
      letterSpacing: "0.16px",
      margin: 0,
    },
    content: {
      marginLeft: 8,
    },
  };
};

export default function StatusWidget({
  icon,
  title,
  info,
  index,
  download,
  downloadRport,
}) {
  const styles = useStyle(icon);

  return (
    <div style={styles.containerStyle}>
      <p style={styles.index}>{index} .</p>
      <div style={styles.iconStyle} />
      <h1 style={styles.header}>{title}</h1>
      <p style={styles.info}>{info}</p>
      {download && (
        <IconButton onClick={downloadRport} style={{ marginLeft: 12 }}>
          <Download style={{ color: "#F53689" }} />
        </IconButton>
      )}
    </div>
  );
}
